import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
  useEventCallback,
} from '@mui/material';
import { memo, useEffect } from 'react';
import { PmiInputFile } from 'shell/components/shared/file-input';
import DeleteIcon from '@mui/icons-material/Delete';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
// import ListTypeDocument from 'shell/components/shared/list-type-document';
import { DocumentVM } from 'subscription/view-models/common-interface-subscription';

interface FormProps {
  disabled?: boolean;
  onChange: (key: keyof DocumentVM, value: DocumentVM[keyof DocumentVM]) => void;
  onChanges: (values: DocumentVM) => void;
  values?: DocumentVM;
}

const FormComponent = ({
  disabled,
  onChange,
  values,
  onChanges,
}: FormProps): React.ReactElement => {
  // const [errorListTypeDocument, setErrorListTypeDocument] = useState<boolean>(false);

  // const insertData = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/allegati`, {
  //   options: { method: 'POST' },
  // });

  // const deleteData = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/allegati`, {
  //   options: { method: 'DELETE' },
  // });

  useEffect(() => {
    if (values?.isNotDocument) {
      // reset files
      onChanges({
        ...(values || {}),
        files: undefined,
        typeDocument: undefined,
      });
    }
  }, [values?.isNotDocument]);

  const handleAddFile = useEventCallback((files: Array<File>) => {
    // if (!values?.typeDocument) {
    //   // inserire tutti i campi obbligatori
    //   setErrorListTypeDocument(true);

    //   return;
    // }

    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      const { result } = event.target || {};

      const newFiles: Array<TypeFile> = values?.files?.slice() || [];

      const filesInsert: Array<TypeFile> = [
        {
          ...files[0],
          raw: result as string,
          idAllegato: 0,
          name: files[0].name || '',
        },
      ];

      onChanges({
        ...(values || {}),
        files: newFiles.concat(filesInsert),
        typeDocument: undefined,
      });
    });

    reader.readAsDataURL(files[0]);
  });

  const onTrashPress = useEventCallback((indexCurr: number) => {
    const newFiles: Array<TypeFile> =
      (values?.files || []).filter((_, index) => index !== indexCurr) || [];

    onChange('files', newFiles);
  });

  // const handleListTypeDocumentChange = useEventCallback((event: SelectChangeEvent<string>) => {
  //   onChange('typeDocument', event.target.value);
  //   setErrorListTypeDocument(false);
  // });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="isTranscribed"
              checked={values?.isNotDocument || false}
              onChange={() => onChange('isNotDocument', !values?.isNotDocument)}
              inputProps={{ 'aria-label': 'Non sono presenti documenti da allegare alla pratica' }}
              disabled={disabled}
            />
          }
          label="Non sono presenti documenti da allegare alla pratica"
        />
      </Grid>
      {/* <Grid item xs={12} md={10}>
        <ListTypeDocument
          value={values?.typeDocument || ''}
          onChange={handleListTypeDocumentChange}
          disabled={disabled || values?.isNotDocument}
          error={errorListTypeDocument}
        />
      </Grid> */}
      <Grid item xs={12}>
        Carica documento&nbsp;
        <PmiInputFile
          files={values?.files}
          onChange={handleAddFile}
          color="cdmBrandThird"
          multiple
          hideList
          disabled={disabled || values?.isNotDocument}
        />
      </Grid>
      <Grid item xs={12}>
        {values?.files?.map((file, index) => (
          <Grid container spacing={2} item xs={12} key={`file-${file.name}-${index}`}>
            <Grid item xs={12} md={4}>
              <Tooltip arrow title={values.descriptions ? values.descriptions[index] : ''}>
                <a download={file.name} href={file.raw}>
                  {file.name}
                </a>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={5}>
              <IconButton
                color="error"
                aria-label="eliminare documento allegato"
                component="span"
                onClick={() => onTrashPress(index)}
                disabled={disabled}
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Practice Detail - Form - accordion contacts - form';

const Form = memo(FormComponent);

export default Form;
